import { createElement, useEffect, useState } from 'react';
import './index.scss';
import { Message } from '@alifd/next';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import { fetchApplication } from '../../../api/report';
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const appid = urlParams.get('applicationId');
const Image = (props) => {
    const { url, title, alt, styles, style, position, inline, dynamic, dynamicType } = props;
    const [error, setError] = useState(false);
    const [styleSet, setStyleSet] = useState({});
    useEffect(() => {
        setStyleSet({
            ...styles,
            width: styles?.widthHeightVisible ? styles.width + 'px' : 'unset',
            height: styles?.widthHeightVisible ? styles.height + 'px' : 'unset',
            display: inline ? 'inline-block' : 'block',
            verticalAlign: 'middle',
        });
    }, [styles, inline]);
    const [iurl, setIurl] = useState('');
    useEffect(() => {
        if (dynamic) {
            if (dynamicType === 'appIcon') {
                if (appid) {
                    fetchApplication(appid).then((res) => {
                        setIurl(res.data.applicationIconImg);
                    });
                }
                else {
                    Message.error('应用id丢失!');
                }
            }
        }
        else {
            setIurl(url);
        }
    }, [dynamic, dynamicType, url]);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref })) : (createElement("div", { className: "base-img-box base_bg", style: { ...style, ...styleSet }, title: title },
        createElement("img", { src: iurl, style: { objectFit: position }, alt: alt })))));
};
export default Image;
